export default "__VITE_ASSET__C5MW8UuO__"